import React from 'react';

import { capitalize } from 'lodash/fp';
import { TronWeb } from 'tronweb';

import { Currency } from '@/constants';
import { truncateMidAddressInputValue } from '@/utils';

import BuildDetailsCopyBadge from '../components/BuildDetailsCopyBadge';
import BuildDetailsGrid, { BuildDetailsGridLabelValuePair } from '../components/BuildDetailsGrid';
import BuildDetailsL1ContractExplorerLink from '../components/BuildDetailsL1ContractExplorerLink';

const BuildDetailsTokenInfoL1Contract: React.FC<{
  currency: Currency;
  l1ContractProp: string;
  l1ContractData: { id: string };
}> = ({ currency, l1ContractProp, l1ContractData }) => {
  if (!l1ContractData) {
    return null;
  }

  const isValidContractId = l1ContractData.id?.startsWith('0x') || TronWeb.isAddress(l1ContractData.id);

  return (
    <BuildDetailsGrid
      collapsible
      content={
        <ul>
          <li>
            <BuildDetailsGrid>
              <BuildDetailsGridLabelValuePair
                label={'Explorer'}
                value={<BuildDetailsL1ContractExplorerLink currency={currency} id={l1ContractData.id} />}
              />
            </BuildDetailsGrid>
          </li>
        </ul>
      }
    >
      <BuildDetailsGridLabelValuePair
        label={l1ContractProp.split('_').map(capitalize).join(' ')}
        value={
          isValidContractId ? (
            <BuildDetailsCopyBadge
              value={l1ContractData.id}
              maskValue={(value) => truncateMidAddressInputValue(String(value), 24)}
            />
          ) : (
            l1ContractData.id
          )
        }
      />
    </BuildDetailsGrid>
  );
};

export default BuildDetailsTokenInfoL1Contract;
